import Link from 'containers/LinkWrapperContainer';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get } from 'lodash';

import { injectParamsInRoute } from 'utils';
import config from 'config';

export default class Breadcrumbs extends Component {
  static propTypes = {
    currentPageTitle: PropTypes.string,
    router: PropTypes.object,
  };

  getLinks() {
    const { router } = this.props;

    const links = [];
    let parent = get(router, 'result.parent');

    if (!parent) {
      return links;
    }

    while (parent) {
      links.push({
        title: parent.title,
        href: injectParamsInRoute(parent.route, router.params),
      });

      parent = parent.parent;
    }

    return links.reverse();
  }

  render() {
    const { router, currentPageTitle } = this.props;

    if (
      config.isInspectorArm &&
      currentPageTitle &&
      ('' + currentPageTitle).indexOf('Мои декларации') !== -1
    ) {
      return null;
    }

    return (
      <div className="breadcrumbs">
        {this.getLinks().map(function (link, i) {
          if (!get(link, 'title')) {
            return null;
          }
          return (
            <span key={i}>
              <Link href={link.href}>{link.title}</Link>
              &nbsp;/&nbsp;
            </span>
          );
        })}
        {currentPageTitle || get(router, 'result.title')}
      </div>
    );
  }
}
